import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/allStars_logo_white.png'
import _imports_1 from '@/assets/img/navbar/dashboard_icon.svg'
import _imports_2 from '@/assets/img/arrow_right_white.svg'
import _imports_3 from '@/assets/img/navbar/user_icon.svg'
import _imports_4 from '@/assets/img/navbar/dictionary_icon.svg'
import _imports_5 from '@/assets/img/navbar/configuration_icon.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-680ca266")

_pushScopeId("data-v-680ca266")
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "icon",
  src: _imports_1
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "chevron me-0",
  src: _imports_2
}, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "icon",
  src: _imports_3
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "chevron me-0",
  src: _imports_2
}, null, -1)
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "icon",
  src: _imports_4
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "chevron me-0",
  src: _imports_2
}, null, -1)
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "icon",
  src: _imports_5
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "chevron me-0",
  src: _imports_2
}, null, -1)
const _hoisted_15 = { class: "logout_div" }
const _hoisted_16 = { class: "white fw_600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("div", {
    class: ["sideBar bg_blue", { menuOpened: _ctx.isMenuOpen }]
  }, [
    _createVNode("nav", _hoisted_1, [
      _createVNode("img", {
        class: "logo_image pointer",
        src: _imports_0,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/dashboard')))
      })
    ]),
    _createVNode("ul", _hoisted_2, [
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/dashboard",
        alt: "Dashboard"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Dashboard",
              text: "Dashboard"
            })
          ]),
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/users",
        alt: "Utenze"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Utenze",
              text: "Utenze"
            })
          ]),
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/dictionary",
        alt: "Traduzioni"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Traduzioni",
              text: "Traduzioni"
            })
          ]),
          _hoisted_11
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        tag: "li",
        class: "li",
        to: "/app-configuration",
        alt: "Configurazione"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_localized_text, {
              class: "fev_text6 fw_600",
              localizedKey: "backoffice_Configurazione",
              text: "Configurazione"
            })
          ]),
          _hoisted_14
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$store.state.loggedUser.username), 1),
      _createVNode("a", {
        class: "logout_clickable",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "backoffice_Logout",
          text: "Logout"
        })
      ])
    ])
  ], 2))
})